module.exports = __webpack_public_path__ + "static/img/portal-liquidFill1.8114b46d.png";